import { render, staticRenderFns } from "./aiLectureModifyPage.vue?vue&type=template&id=6400509c&scoped=true&"
import script from "./aiLectureModifyPage.vue?vue&type=script&lang=js&"
export * from "./aiLectureModifyPage.vue?vue&type=script&lang=js&"
import style0 from "./aiLectureModifyPage.vue?vue&type=style&index=0&id=6400509c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400509c",
  null
  
)

export default component.exports